import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { SvcActionplanComponent } from './svc-actionplan.component';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { LibSharedComponentModule } from '@solvace/component';
import { SvcSearchFieldModule } from '@solvace/component/svc-search-field';
import { SvcSmartUserAvatarModule } from '@solvace/feature/general/svc-smart-user-avatar';
import { SvcStatusBadgeModule } from '@solvace/component/svc-status-badge';
import { SvcControlsModule } from '@solvace/component/svc-controls';
import { SvcLockButtonModule } from '@solvace/component/svc-lock-button';
import { TranslocoModule } from '@ngneat/transloco';
import { SvcTotalsStatusModule } from '../svc-totals-status/svc-totals-status.module';
import { SvcPaginateModule } from '@solvace/component/svc-paginate';
import { SvcFilledBtnIconModule } from '@solvace/component/svc-btn-icon';
import { SvcBtnModule } from '@solvace/component/svc-btn';

@NgModule({
  declarations: [
    SvcActionplanComponent,
  ],
  imports: [
    CommonModule,
    LibSharedCommonModule,
    LibSharedComponentModule,
    TranslocoModule,
    SvcControlsModule,
    SvcSmartUserAvatarModule,
    SvcStatusBadgeModule,
    SvcTotalsStatusModule,
    SvcLockButtonModule,
    SvcSearchFieldModule,
    SvcPaginateModule,
    SvcFilledBtnIconModule,
    SvcBtnModule,
    MatDialogModule,
  ],
  exports: [
    SvcActionplanComponent,
  ]
})
export class SvcActionplanModule { }
